import { Container, Text } from "@marketplace/ui";
import { useTranslation } from "react-i18next";

import { Accounts } from "./accounts";

export const PreviewFooter = () => {
  const { t } = useTranslation("common", {
    keyPrefix: "previewLayout"
  });

  return (
    <footer className="hidden md:block bg-humble-blue-500 w-full pt-[60px] pb-[86px] md:pb-6">
      <Container className="!px-4 !md:px-2 text-brand-white mb-[23px] flex flex-col md:flex-row justify-between w-full gap-y-[52px]">
        <div className="flex flex-col gap-y-3">
          <div>
            <div className="text-h-xl mb-2">
              {t("footer.collaboration.title")}
            </div>
            <div className="text-h-s">
              {t("footer.collaboration.description")}
            </div>
          </div>
        </div>

        <div className="flex flex-wrap gap-x-2 gap-y-[52px]">
          <div className="flex gap-x-2 flex-grow justify-between">
            <nav className="w-auto sm:w-[180px] flex-shrink-0">
              <div className="text-h-s mb-6">{t("footer.support")}</div>
              <div className="flex flex-col gap-y-3">
                <Text>{t("header.howItWorks")}</Text>
                <Text>{t("footer.explore")}</Text>
                <Text>{t("header.aboutUs")}</Text>
              </div>
            </nav>

            <nav className="w-auto sm:w-[180px] flex-shrink-0">
              <div className="text-h-s mb-6">{t("footer.policies.title")}</div>
              <div className="flex flex-col gap-y-3">
                <Text>{t("footer.policies.faq")}</Text>
                <Text>{t("footer.policies.termsAndConditions")}</Text>
                <Text>{t("footer.policies.privacyPolicy")}</Text>
              </div>
            </nav>
          </div>

          <div className="w-[216px] flex-shrink-0">
            <div className="text-h-s mb-6">{t("footer.getInTouch")}</div>

            <div className="flex flex-col gap-y-3">
              <div className="flex gap-x-3">
                <Text>{t("footer.address")}</Text>
              </div>

              <div className="flex items-center gap-x-3">
                <Text>{t("footer.email")}</Text>
              </div>
            </div>
          </div>
        </div>
      </Container>

      <Container className="block md:hidden mb-6 !max-w-fit mt-20">
        <Accounts />
      </Container>

      <Container className="!px-4 !md:px-2 mb-6">
        <hr className="bg-fjord-grey-100 h-px border-0" />
      </Container>

      <Container className="!px-4 !md:px-2 text-brand-white flex items-center justify-between">
        <div>
          &copy; {new Date().getFullYear()}{" "}
          <span className="font-bold">{t("footer.copyright")}</span>
        </div>
        <div className="hidden md:block">
          <Accounts />
        </div>
      </Container>
    </footer>
  );
};
